import { render, staticRenderFns } from "./mobileTips.vue?vue&type=template&id=11c228dc&scoped=true"
import script from "./mobileTips.vue?vue&type=script&lang=js"
export * from "./mobileTips.vue?vue&type=script&lang=js"
import style0 from "./mobileTips.vue?vue&type=style&index=0&id=11c228dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c228dc",
  null
  
)

export default component.exports